export function downloadFileWithContents(filename, content, type = "text/plain") {
    const blob = new Blob([content], { type });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = filename;

    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(url);
}

export async function downloadFile(token, id, filename) {
    const url = process.env.REACT_APP_API_URL + `/architectures/${id}/get-files`
    const headers = {'Authorization': token, 'x-api-key': process.env.REACT_APP_API_KEY, Accept: "application/zip"}

    const res = await fetch(url, {
        method: "GET",
        headers: headers
    });

    if (!res.ok) throw new Error(`Download failed: ${res.status}`);

    const blob = await res.blob();
    const objectUrl = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = filename;

    document.body.appendChild(a);

    a.click();
    a.remove();

    URL.revokeObjectURL(objectUrl);
}

export class Endpoint {
    constructor(path, headers={}, body={}, method='GET') {
        this.url = process.env.REACT_APP_API_URL + path
        this.method = method
        this.body = body
        this.headers = headers
    }

    static listEnums(token) {
        return new Endpoint('/list-enums', {'Authorization': token, 'x-api-key': process.env.REACT_APP_API_KEY})
    }

    static queryArchitectures(token) {
        return new Endpoint('/architectures', {'Authorization': token, 'x-api-key': process.env.REACT_APP_API_KEY})
    }

    static getArchitecture(token, id) {
        return new Endpoint('/architectures/' + id, {'Authorization': token, 'x-api-key': process.env.REACT_APP_API_KEY})
    }

    static generateArchitecture(token, payload) {
        return new Endpoint(
            '/generate-architecture',
            {'Authorization': token, 'x-api-key': process.env.REACT_APP_API_KEY},
            payload,
            'POST'
        )
    }

    static putArchitecture(token, payload) {
        return new Endpoint(
            '/architectures',
            {'Authorization': token, 'x-api-key': process.env.REACT_APP_API_KEY},
            payload,
            'PUT'
        )
    }

    static deleteArchitecture(token, id) {
        return new Endpoint(
            '/architectures/' + id,
            {'Authorization': token, 'x-api-key': process.env.REACT_APP_API_KEY},
            {},
            'DELETE'
        )
    }

    static browseArchitectureFiles(token, id, path) {
        const params = new URLSearchParams({
            path: path,
        });

        return new Endpoint(
            '/architectures/' + id + '/browse-files?' + params.toString(),
            {'Authorization': token, 'x-api-key': process.env.REACT_APP_API_KEY},
            'GET'
        )
    }

    static getFileContents(token, id, key) {
        return new Endpoint(
            '/architectures/' + id + '/get-files/' + encodeURIComponent(key),
            {'Authorization': token, 'x-api-key': process.env.REACT_APP_API_KEY},
            'GET'
        )
    }
}

export const sendRequest = (endpoint) => {
    return fetch(endpoint.url, {
        method: endpoint.method,
        headers: endpoint.headers,
        body: endpoint.method === "GET"? null : JSON.stringify(endpoint.body)
    })
}

export const handleResponse = (response) => {
    if (!response.ok) {
        return response.json()
            .catch(() => {
                throw new Error(response.status);
            })
            .then(({message}) => {
                throw new Error(message || response.status);
            });
    }

    return response.json();
}
